import React, { useState } from 'react';
import BtnCloseModal from '../../components/btnCloseModal/BtnCloseModal.js';
import { FaRocket } from 'react-icons/fa';
import { BsGithub } from 'react-icons/bs';

import './projectCard.css';

const ProjectCard = ({ project }) => {
  const [imageModalIsOpen, setImageModalIsOpen] = useState(false);
  const openImage = () => {
    setImageModalIsOpen(true);
  };
  return (
    <>
      {imageModalIsOpen && (
        <div className="modalContainer">
          <img
            src={require(`../../assets/projects/${project.image}`)}
            alt={project.title}
            className="imageModal"
            onClick={() => setImageModalIsOpen(false)}
          />
          <div onClick={() => setImageModalIsOpen(false)}>
            <BtnCloseModal />
          </div>
        </div>
      )}
      <div className="projectCardContainer">
        <h2>{project.title}</h2>
        <img
          src={require(`../../assets/projects/${project.image}`)}
          alt={project.title}
          className="projectImage"
          onClick={() => openImage()}
        />
        <p className="projectDescription">{project.description}</p>
        <p className="projectTechnologies">{project.technologies}</p>
        <img
          src={require(`../../assets/projects/${project.image}`)}
          alt={project.title}
          className="projectBgImage"
        />
        <div className="projectIconsContainer">
          <a
            href={project.deploy}
            target="_blank"
            rel="noreferrer"
            className="projectIcon"
          >
            <FaRocket />
          </a>
          <a
            href={project.github}
            target="_blank"
            rel="noreferrer"
            className="projectIcon"
          >
            <BsGithub />
          </a>
        </div>
      </div>
    </>
  );
};

export default ProjectCard;
